module.exports = __webpack_public_path__ + "img/ft-rotate-right.c1909fad.svg";